module.exports = __webpack_public_path__ + "static/img/sjmb.260f9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/sjmb.png
// module id = 1263
// module chunks = 0